import { useCallback, useEffect, useState } from 'react';

import { PlusCircleOutlined } from '@ant-design/icons';
import { Table, notification, Button, Divider, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';

import locationsService from '../../../../services/industry/locationsService';
import StaticPage from '../../../../typings/StaticPage';
import TitledCard from '../../../layout-components/titled-card';
import Flex from '../../../layouts/flex';

const LocationsList: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState<Array<StaticPage>>([]);

  const reloadList = () => {
    locationsService.getLocations().then((response) => {
      setLocations(response.static_pages);
      setLoading(false);
    });
  };

  useEffect(reloadList, []);

  const removeItem = useCallback((record: StaticPage) => {
    setLoading(true);
    locationsService
      .deleteLocation(record.slug)
      .then(() => {
        notification.success({
          message: 'Usunięto miejsce',
          description: (
            <>
              Miejsce <strong>{record.title_pl}</strong> zostało usunięte.
            </>
          ),
        });
        reloadList();
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const columns = [
    {
      title: 'Nazwa',
      dataIndex: 'title_pl',
      render: (title_pl: string, record: StaticPage) => (
        <Link to={`${record.slug}/edit`}>{title_pl}</Link>
      ),
    },
    {
      title: 'Nazwa (EN)',
      dataIndex: 'title_en',
    },
    {
      title: 'Zdjęcie',
      dataIndex: 'thumb_cover_image_url',
      render: (coverImageUrl: string | null, record: StaticPage) =>
        coverImageUrl ? <img src={coverImageUrl} alt={record.title_pl} /> : null,
      align: 'center' as const,
      width: 200,
    },
    {
      title: 'Operacje',
      key: 'action',
      width: 200,
      align: 'center' as const,
      render: (_text: string, record: StaticPage) => (
        <span>
          <Link to={`${record.slug}/edit`}>
            <Button type="primary" size="small">
              Edycja
            </Button>
          </Link>

          <Divider type="vertical" />

          <Popconfirm
            title={
              <>
                Czy na pewno usunąć miejsce <strong>{record.title_pl}</strong>?
              </>
            }
            onConfirm={() => removeItem(record)}
            okText="Tak"
            cancelText="Nie"
          >
            <Button type="primary" size="small" danger>
              Usuń
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];

  return (
    <TitledCard title="Lista miejsc">
      <Flex className="mb-3" alignItems="center" justifyContent="end" mobileFlex={false}>
        <div>
          <Link to="new">
            <Button type="primary" icon={<PlusCircleOutlined />} block>
              Dodaj miejsce
            </Button>
          </Link>
        </div>
      </Flex>
      <Table
        rowKey="id"
        dataSource={locations}
        columns={columns}
        bordered
        loading={loading}
        pagination={false}
      />
    </TitledCard>
  );
};
export default LocationsList;
